import React, { Component } from "react";
import "./Start.scss";
import startafbeelding from "../Images/start.png";
import bosplus from "../Images/bosplus-start.png";
import knop from "../Images/knop-start.png";

class Start extends Component {
  render() {
    return (
      <>
      <div className="left" style={{
        paddingBottom: "100px"
      }}>
        Welkom op de online les van Het verhaal van Mascopiro! Deze interactieve les is bedoeld voor leerlingen van het derde t.e.m. zesde leerjaar. Jij en je klas kunnen hier kennismaken met het Amazonewoud via filmpjes, interactieve oefeningen en een spannend verhaal.
        <br /><br />
        Deze les werd gemaakt door BOS+. Na meer dan 200 voorleesmomenten in verschillende scholen zagen we het succes van deze workshop niet afnemen, en besloten we een online versie te maken die door leerkrachten zelf begeleid kan worden. Projecteer de filmpjes via de beamer of het smartboard. Bij de korte oefeningen kan je de kinderen om beurt naar voor laten komen. In hoofdstuk 2 kan je zelf een stukje voorlezen uit het boek, of je kan een (groot)ouder uitnodigen om dat te doen. Hoofdstuk 4 bevat een klein groepswerk, maar afhankelijk van de leeftijd van je leerlingen kan de oefening ook klassikaal gedaan worden.
        <br /><br />
        Het bijhorend boek kan je vinden bij je bibliotheek of kan je kopen via <a className="link" href="www.bosplus.be/boswinkel">www.bosplus.be/boswinkel</a>. Je vindt er ook andere leuke bosboeken zoals Het Grote Bomenboek, Woudapen, Lou in het herfstbos, ... Bovendien geniet je als leerkracht van 10% korting met je lerarenkaart! Ben je niet in de mogelijkheid om het boek te gaan halen? Download dan de tekst via de knop onderaan deze pagina. BOS+ heeft nog heel wat andere projecten voor lagere scholen, neem gerust een kijkje op onze website via <a className="link" href="www.bosplus.be/leerkrachten">www.bosplus.be/leerkrachten</a>.
        <br/>
        <img className="boslogo" src={bosplus}></img>
        <div className="flex">
            <div className="knop" onClick={() => (window.location = "/1/Inleiding")}>
                Naar hoofdstuk 1
            </div>
            <div className="knop max1" onClick={() => (window.location = "https://www.bosplus.be/nl/voor-leerkrachten")}>
                Neem een kijkje op onze website
            </div>
            <div className="knop max2" onClick={() => (window.location = "/verhaal.pdf")}>
                Download het verhaal van Mascopiro
            </div>
        </div>
        
      </div>
      <div className="right">
        <img className="cover" src={startafbeelding}></img>
      </div>
      </>
    );
  }
}

export default Start;
